export default __webpack_public_path__ + "13.06.2017-PM_LifeTime_Innovationsfondsprojekt INVEST5588fcffe06e2c9972c99be3dfdc0443.pdf";